import { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import FormGroup from '../../FormGroup';
import usePostData from '../../../hooks/usePostData';
import PersonalHeader from '../../PersonalDetails/components/header';
import { ReactComponent as SmsIcon } from '../../../assets/images/sms.svg';
import { ReactComponent as EyeIcon } from '../../../assets/images/eye.svg';
import { invalidDate } from '../../../utils';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import translating from '../translate.json';
import GlobalContext from 'contexts';
import PersonalDetailsContent from 'components/PersonalDetails/components/content';

const CustomerDetails = ({
  data,
  fields,
  handleUpdate,
  isActive,
  setOpenDrawer,
}) => {
  const [mode, setMode] = useState('view');
  const { res, postData, payload, error } = usePostData();
  const [errFun, setErrFun] = useState();
  const { currentUser, currentCustomer, setCurrentCustomer } =
    useContext(GlobalContext);
  const { id } = useParams();
  useEffect(() => {
    if (error) {
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError,
      });
    } else if (res && res.affected === 1 && payload && handleUpdate) {
      handleUpdate(payload);
      setMode('view');
      setCurrentCustomer(payload);
    }
  }, [res, payload, error]);

  const onSubmit = (data, setError) => {
    let copyData = { ...data };
    delete copyData.organization;
    copyData.address = `${copyData.city},${copyData.street},${copyData.buildingNumber},${copyData.apartmentNumber},`;
    delete copyData.city;
    delete copyData.street;
    delete copyData.buildingNumber;
    delete copyData.apartmentNumber;
    delete copyData.age;
    if (copyData.weight === '') copyData.weight = null;
    if (copyData.height === '') copyData.height = null;
    if (invalidDate(copyData.date_of_birth))
      setError('date_of_birth', {
        type: 'string',
        message: translating.invalidDate,
      });
    else {
      copyData.date_of_birth = new Date(copyData.date_of_birth);
      setErrFun({ set: setError });
      postData(`client/${id}`, copyData, 'patch');
    }
  };

  const actions = [
    {
      icon: SmsIcon,
      txt: translating.sendSMS,
      handleClickAction: () => setOpenDrawer('sendSMS'),
    },
    {
      icon: EyeIcon,
      txt: translating.resetPassword,
      handleClickAction: () => setOpenDrawer('resetPassword'),
    },
  ];

  const roleUser = currentUser.role.name;
  const allowdRules = ['Admin', 'Sales', 'Manager', 'System'];
  const allowedUser = allowdRules.indexOf(roleUser) > -1;

  return (
    <div className="personal-details">
      <PersonalHeader
        title={translating.personalDetailsHeader}
        actions={actions}
        fields={fields}
        mode={mode}
        data={data}
      ></PersonalHeader>

      <div className="wrapper-details">
        <div className="customer-details">
          {allowedUser ? (
            <FormGroup
              fields={fields}
              data={data}
              onSubmit={onSubmit}
            ></FormGroup>
          ) : (
            <PersonalDetailsContent
              data={data}
              fields={fields}
            ></PersonalDetailsContent>
          )}
        </div>
        <div className="customer-status">
          <div className="customer-status-title">{translating.status}</div>
          <div className="customer-status-description">
            {data.isActive
              ? isActive
                ? translating.active
                : translating.noProducts
              : translating.blocked}
          </div>
          <div className="customer-status-title">
            {translating.dateRegister}
          </div>
          <div className="customer-status-title">
            {moment(data?.createdAt).format('DD.MM.YYYY')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetails;

CustomerDetails.propTypes = {
  data: PropTypes.object,
  fields: PropTypes.array,
  handleUpdate: PropTypes.func,
  isActive: PropTypes.any,
  setOpenDrawer: PropTypes.func,
};
